// src/router/guards/StudentGuard.tsx
// Route guard — restricts access to students only.
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/app/hooks'
import { RingLoader } from 'react-spinners'

export default function StudentGuard() {
  const { user, isAuthenticated, isInitializing } = useAuth()

  if (isInitializing) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-neutral-50 dark:bg-[#06090d] transition-colors duration-150">
        <RingLoader color="#33cb98" size={80} />
      </div>
    )
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />
  }

  const isStaffOrAdmin =
    user.role?.includes('SUPER_ADMIN') ||
    user.role?.includes('STAFF') ||
    user.primaryRole?.includes('SUPER_ADMIN') ||
    user.primaryRole?.includes('STAFF') ||
    user.roles?.some((r) => r.includes('SUPER_ADMIN') || r.includes('STAFF'))

  // If a SuperAdmin or Staff navigates to /student, direct them to their admin dashboard
  if (isStaffOrAdmin) {
    return <Navigate to="/dashboard" replace />
  }

  const isStudent =
    user.role?.includes('STUDENT') ||
    user.primaryRole?.includes('STUDENT') ||
    user.roles?.some((r) => r.includes('STUDENT')) ||
    user.userType === 'STUDENT'

  if (!isStudent) {
    return <Navigate to="/unauthorized" replace />
  }

  return <Outlet />
}
